import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import RoleRoute from "./components/private/roleRoute";

import MainLayout from "./layouts/publicLayout";
import PrivateLayout from "./layouts/privateLayout"
import PrivateRoute from "./components/privateRoute"; 
import ModuleWrapper from "./components/private/moduleWrapper";

// Imports pagina web y login
import Home from "./pages/home";
import Ofertas from "./pages/ofertas";
import DetalleOferta from "./pages/detalleOferta";
import Login from "./pages/login";
import Register from "./pages/registerUser";
import ForgotPassword from "./pages/forgotPassword";
// Imports dashboard
import Dashboard from "./pages/session/dashboard";
import DashboardExterno from "./pages/session/dashboardexterno";

// Imports GESTIÓN HUMANA
import User from "./pages/session/user/user";
import CreateUser from "./pages/session/user/createUser";
import Offers from "./pages/session/offer/offers";
import UpdateOffer from "./pages/session/offer/updateOffer";
import CreateOffer from "./pages/session/offer/createOffer";
import Externaloffers from "./pages/session/offer/externalOffers";
import Profile from "./pages/session/profile";
import Postulations from "./pages/session/postulation/postulations";
import ExternalPostulations from "./pages/session/postulation/externalPostulation";
import Curriculum from "./pages/session/curriculum/curriculum";
import MyCurriculum from "./pages/session/curriculum/myCurriculum";
import UpdateCurriculum from "./pages/session/curriculum/updateCurriculum";
import ContractGH from "./pages/session/contract_gh/contract";
import CreateContract from "./pages/session/contract_gh/createContract";
import Certificate from "./pages/session/contract_gh/certificate";
import Minutas from "./pages/session/contract_gh/minutas";
import Report from "./pages/session/report/report";
import Otrosi from "./pages/session/contract_gh/otrosi";
import OccupationalExam from "./pages/session/occupational_exam/occupationalExam";
import Interview from "./pages/session/interview/interview";
import CreateInterview from "./pages/session/interview/createInterview";

// imports de PLAN ACCIÓN
import PlanAccion from "./pages/session/plan_accion/plan_accion";
import Programas from "./pages/session/plan_accion/programas";
import CreatePlan from "./pages/session/plan_accion/createPlan";
import GestionarPlan from "./pages/session/plan_accion/gestionar";
import GestionarActividad from "./pages/session/plan_accion/gestionar_actividad";
import TiempoEjecucion from "./pages/session/plan_accion/tiempo_ejecucion";

// Imports de PROYECTOS
import Entity from "./pages/session/mod_proyectos/entity/entity";
import Proposal from "./pages/session/mod_proyectos/proposal/proposal";
import CreateProposal from "./pages/session/mod_proyectos/proposal/createProposal";
import ViewProposal from "./pages/session/mod_proyectos/proposal/viewProposal";
import UpdateProposal from "./pages/session/mod_proyectos/proposal/updateProposal";
// contrato de proyectos
import Contrato from "./pages/session/mod_proyectos/contrato_proyectos/contrato";
import CreateContrato from "./pages/session/mod_proyectos/contrato_proyectos/createContrato";
import UpdateContrato from "./pages/session/mod_proyectos/contrato_proyectos/updateContrato";

const App = () => {
  return (
    <Router>
      <Routes>
        {/*  Páginas públicas */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/ofertas" element={<Ofertas />} />
          <Route path="/detalleOferta/:id" element={<DetalleOferta />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgotPassword" element={<ForgotPassword />} />
        </Route>

        {/*  Rutas privadas protegidas */}
        <Route element={<PrivateRoute />}>
          <Route element={<PrivateLayout />}>
          
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Coordinador", "Externo", "Apoyo", "Sst", "Empleado",  "Comunicaciones" ]} />}>
                <Route path="/session/dashboard" element={
                  <ModuleWrapper
                     roleComponents={{
                      SuperAdmin: <Dashboard />,
                      Coordinador: <Dashboard />,
                      Auditor: <Dashboard />,
                      Apoyo: <Dashboard />,
                      Sst: <Dashboard />,
                      Comunicaciones: <Dashboard />,
                      Externo: <DashboardExterno />,
                      Empleado: <DashboardExterno />
                    }}
                  />}
                />
            </Route>
            <Route path="/session/profile" element={<Profile />} />

            {/* OFERTAS */}
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Coordinador", "Externo", "Comunicaciones", "Empleado", "Sst", "Apoyo"]} />}>
                <Route path="/session/offer/offers" element={
                  <ModuleWrapper
                    roleComponents={{
                      SuperAdmin: <Offers />,
                      Auditor: <Offers />,
                      Comunicaciones: <Offers />,
                      Coordinador: (user) =>
                        Number(user.area) === 5 ? <Offers /> : <Externaloffers />,
                      Apoyo: (user) =>
                        Number(user.area) === 5 ? <Offers /> : <Externaloffers />,
                      Externo: <Externaloffers />,
                      Empleado: <Externaloffers />,
                      Sst: <Externaloffers />
                    }}
                  />
                }
                />
            </Route>
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Coordinador", "Comunicaciones"]} />}>
                <Route path="/session/offer/updateOffer/:id" element={<UpdateOffer />} />
            </Route>
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Coordinador", "Comunicaciones"]} />}>
                <Route path="/session/offer/createOffer" element={<CreateOffer />} />
            </Route>
           
            {/* USUARIOS */}
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor"]} />}>
                <Route path="/session/user/user" element={<User />} />
            </Route>
             <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor"]} />}>
                <Route path="/session/user/createUser" element={<CreateUser />} />
             </Route>


            {/* POSTULACIONES */}
              <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor","Externo", "Apoyo", "Sst", "Coordinador", "Empleado", "Comunicaciones"]} />}>
                  <Route path="/session/postulation/postulations" element={
                    <ModuleWrapper
                    roleComponents={{
                      SuperAdmin: <Postulations />,
                      Auditor: <Postulations />,
                      Coordinador: (user) =>
                        Number(user.area) === 5 ? <Postulations /> : <ExternalPostulations />,
                      Apoyo: (user) =>
                        Number(user.area) === 5 ? <Postulations /> : <ExternalPostulations />,
                      Sst: <ExternalPostulations />,
                      Comunicaciones: <Postulations/>,
                      Externo: <ExternalPostulations />,
                      Empleado: <ExternalPostulations />
                    }}
                    />}
                  />
              </Route>
            {/* CURRICULUM */}
              <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Apoyo", "Coordinador"]} />}>
                <Route path="/session/curriculum/curriculum" element={<Curriculum />} />
              </Route>
              <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Apoyo", "Coordinador"]} />}>
                <Route path="/session/curriculum/updateCurriculum/:id" element={<UpdateCurriculum />} />
              </Route>
              <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Apoyo", "Coordinador", "Empleado", "Externo", "Comunicaciones", "Sst"]} />}>
                <Route path="/session/curriculum/mycurriculum" element={<MyCurriculum />} />
              </Route>


            {/* CONTRATO GH */}
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor",  "Apoyo", "Coordinador"]} />}>
                <Route path="/session/contract_gh/contract" element={<ContractGH />} />
            </Route>
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor",  "Apoyo", "Coordinador"]} />}>
                <Route path="/session/contract_gh/createContract" element={<CreateContract />} />
            </Route>
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Apoyo", "Coordinador"]} />}>
                <Route path="/session/contract_gh/certificate" element={<Certificate />} />
            </Route>
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Apoyo", "Coordinador"]}/>}>
                <Route path="/session/contract_gh/minutas" element={<Minutas />} />
            </Route>
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Apoyo", "Coordinador"]} />}>
                <Route path="/session/report/report" element={<Report />} />
            </Route>
            {/* OTROSI */}
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Apoyo", "Coordinador"]} />}>
                <Route path="/session/contract_gh/otrosi" element={<Otrosi />} />
            </Route>

            {/* EXAMEN OCUPACIONAL */}
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Sst", "Coordinador"]} />}>
                <Route path="/session/occupational_exam/occupationalExam" element={<OccupationalExam />} />
            </Route>

            {/* ENTREVISTAS */}
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Apoyo", "Auditor", "Coordinador"]} />}>
                <Route path="/session/interview/interview" element={<Interview />} />
            </Route>
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Apoyo", "Auditor", "Coordinador"]} />}>
                <Route path="/session/interview/createInterview" element={<CreateInterview />} />
            </Route>

            {/* PLAN DE ACCION */}
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Coordinador"]} />}>
                <Route path="/session/plan_accion/programas" element={<Programas />} />
            </Route>
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Coordinador"]} />}>
                <Route path="/session/plan_accion/plan_accion" element={<PlanAccion />} />
            </Route>
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Coordinador"]} />}>
                <Route path="/session/plan_accion/createPlan" element={<CreatePlan />} />
            </Route>
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Coordinador"]} />}>
                <Route path="/session/plan_accion/gestionar/:id" element={<GestionarPlan />} />
            </Route>
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Coordinador"]} />}>
                <Route path="/session/plan_accion/gestionar_actividad/:id" element={<GestionarActividad />} />
            </Route>
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Coordinador"]} />}>
                <Route path="/session/plan_accion/tiempo_ejecucion/:id" element={<TiempoEjecucion />} />
            </Route>


            {/* -------------------------------- PROYECTOS ------------------------------ */}
            {/* Entidad */}
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Coordinador", "Apoyo"]} />}>
                <Route path="/session/mod_proyectos/entity/entity" element={<Entity />} />
            </Route>
            {/* Propuesta */}
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Coordinador", "Apoyo"]} />}>
                <Route path="/session/mod_proyectos/proposal/proposal" element={<Proposal />} />
            </Route>
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Coordinador", "Apoyo"]} />}>
                <Route path="/session/mod_proyectos/proposal/createProposal" element={<CreateProposal />} />
            </Route>
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Coordinador", "Apoyo"]} />}>
                <Route path="/session/mod_proyectos/proposal/viewProposal/:id" element={<ViewProposal />} />
            </Route>
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Coordinador", "Apoyo"]} />}>
                <Route path="/session/mod_proyectos/proposal/updateProposal/:id" element={<UpdateProposal />} />
            </Route>
            {/* Contrato */}
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Coordinador", "Apoyo"]} />}>
                <Route path="/session/mod_proyectos/contrato_proyectos/contrato" element={<Contrato />} />
            </Route>
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Coordinador", "Apoyo"]} />}>
                <Route path="/session/mod_proyectos/contrato_proyectos/createContrato" element={<CreateContrato />} />
            </Route>
            <Route element={<RoleRoute allowedRoles={["SuperAdmin", "Auditor", "Coordinador", "Apoyo"]} />}>
                <Route path="/session/mod_proyectos/contrato_proyectos/updateContrato/:id" element={<UpdateContrato />} />
            </Route>



          </Route>
        </Route>
      </Routes>
    </Router>
  );
};

export default App;